import { TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';

import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      marginTop: Spacings.s48,
    },
    title: {
      marginBottom: Spacings.s48,
      fontSize: FontSizes.s36,
      textAlign: 'center',
      color: TextColors.base,

      '& > span': {
        fontWeight: FontWeights.bold,
        color: TextColors.base,
      },
    },
    titleSkeleton: {
      margin: `${Spacings.s48} auto`,
      height: 40,
      maxWidth: '50%',
    },
    spotlights: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridGap: Spacings.s2,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        gridTemplateColumns: '1fr',
      },
    },
    spotlightsSkeleton: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridGap: Spacings.s2,
      height: 500,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        gridTemplateColumns: '1fr',
      },
    },
    item: {
      minWidth: 0,
    },
    itemSkeleton: {
      minWidth: 100,
    },
  }),
  {
    name: 'brands-spotlights',
  },
);

export default useStyles;
